import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="contacto" className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Fiesta del Tendero</h3>
            <p>La celebración que une al comercio en Magangué</p>
          </div>
          
          <div className="footer-section">
            <h4>Contacto</h4>
            <p>Para más información sobre el evento y registro:</p>
            <a href="mailto:fiestadeltenderomagangue@gmail.com" className="footer-email">
              fiestadeltenderomagangue@gmail.com
            </a>
            <p>Magangué, Bolívar, Colombia</p>
          </div>
          
          <div className="footer-section">
            <h4>Información Legal</h4>
            <Link to="/politica-datos" className="footer-link">
              Política de Tratamiento de Datos
            </Link>
            <p>Comercio Unido - Magangué</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Fiesta del Tendero. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;